import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { getInfluencerListApi } from '@src/api';
import { InfluencerParams } from '@api/influencers/index.d';

export const getInfluencerListThunk = createAsyncThunk(
  'project/getInfluencerList',
  async (params: InfluencerParams, { rejectWithValue }) => {
    try {
      const response = await getInfluencerListApi(params);

      return response.result?.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw rejectWithValue(error.response?.data);
      }
      throw error;
    }
  }
);
